import { useSyncExternalStore } from 'react';
import {
  getConsentState,
  isConsentPreferencesOpen,
  subscribeConsent,
  type ConsentState,
} from '../lib/analyticsConsent';

/** Current consent state; re-renders on any choice, withdrawal or cross-tab change. */
export function useAnalyticsConsent(): ConsentState {
  return useSyncExternalStore(subscribeConsent, getConsentState, () => 'unset' as const);
}

/** Whether the visitor asked to reopen the preferences UI (footer entry). */
export function useConsentPreferencesOpen(): boolean {
  return useSyncExternalStore(subscribeConsent, isConsentPreferencesOpen, () => false);
}
